import { graphql } from "react-relay";
import { readInlineData } from "relay-runtime";
import type { NewsletterItem } from "scmp-sdk/components/newsletter/types";

import type { ValidNewsletterSequenceMapKey } from "shared/data/newsletter";
import { NEWSLETTER_PACKAGES, NEWSLETTER_SEQUENCE_MAP } from "shared/data/newsletter";
import { notEmpty } from "shared/lib/utils";

import type { helpersMassageToNewsletterItemNewsletter$key } from "scmp-app/queries/__generated__/helpersMassageToNewsletterItemNewsletter.graphql";

export const massageToNewsletterItem = (
  newsletter_?: helpersMassageToNewsletterItemNewsletter$key | null,
): NewsletterItem | null => {
  const newsletter = readInlineData(
    graphql`
      fragment helpersMassageToNewsletterItemNewsletter on Newsletter @inline {
        entityId
        name
        alternativeName
        description {
          text
        }
        summary {
          text
        }
        homepageDescription {
          text
        }
      }
    `,
    newsletter_ ?? null,
  );
  if (!newsletter) return null;
  return {
    alternativeName: newsletter.alternativeName,
    description: {
      text: newsletter.description?.text ?? "",
    },
    entityId: newsletter.entityId,
    homepageDescription: {
      text: newsletter.homepageDescription?.text ?? "",
    },
    name: newsletter.name,
    summary: {
      text: newsletter.summary?.text ?? "",
    },
  };
};

export function getNextNewsletterPackage(
  placement: ValidNewsletterSequenceMapKey,
  subscribedPackageIds: string[],
) {
  const handler = () => {
    const packageSequence = NEWSLETTER_SEQUENCE_MAP[placement];
    if (!notEmpty(packageSequence)) return;

    for (const packageKey of packageSequence) {
      const packageDetail = NEWSLETTER_PACKAGES[packageKey];
      if (!notEmpty(packageDetail)) return;

      const allSubscribed = packageDetail.childNewsletterIds.every(id =>
        subscribedPackageIds.includes(id),
      );
      if (!allSubscribed)
        return {
          packageDetail,
          packageKey,
        };
    }
  };
  return new Promise<ReturnType<typeof handler>>(resolve => {
    setTimeout(() => {
      resolve(handler());
    }, 1500);
  });
}
